import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { TTableRow, IDeps } from './models';
import { TableRow as Component } from './table-row';
import styles from './styles/styles.css';

export const TableRow = createWidget<IDeps, TTableRow>({ styles })(Component);
